import React from "react";

import * as typography from "@client/shared/typography";

import {Layout} from "@client/site/Layout";

export const Template = () => (
    <Layout narrow title="Terms of Service">
        <typography.Header>Terms of Service</typography.Header>
        <typography.P>
            We (the folks at Joy) run a web site and app service called Joy Health
            Tracker and would love for you to use it. Our service is designed to give
            you as much control and ownership over what goes on your site as possible
            and encourage you to express yourself freely. However, be responsible in
            what you publish. In particular, make sure that none of the prohibited items
            listed below appear on your site or get linked to from your site (things
            like spam, viruses, or hate content).
        </typography.P>

        <h2>Terms of Service</h2>
        <typography.P>
            The following terms and conditions govern all use of the joyapp.com website,
            app and all content, services and products available at or through the
            website. The Website and Application are owned and operated by Joy Network,
            LLC (&ldquo;Joy&rdquo;). The Website and App are offered subject to your
            acceptance without modification of all of the terms and conditions contained
            herein and all other operating rules, policies (including, without
            limitation, Joy&rsquo;s Privacy Policy) and procedures that may be published
            from time to time on this Site by Joy (collectively, the
            &ldquo;Agreement&rdquo;).
        </typography.P>
        <typography.P>
            Please read this Agreement carefully before accessing or using the Website
            or Application. By accessing or using any part of the site or app, you agree
            to become bound by the terms and conditions of this agreement. If you do not
            agree to all the terms and conditions of this agreement, then you may not
            access the Website, App, or use any services. If these terms and conditions
            are considered an offer by Joy, acceptance is expressly limited to these
            terms. The Website and App are available only to individuals who are at
            least 13 years old.
        </typography.P>
        <typography.P>
            You may review the latest terms of service at
            https://www.joyapp.com/terms-of-service/
        </typography.P>

        <h3>Responsibility of Contributors.</h3>
        <typography.P>
            If you post material to the Website or Application, post links on the
            Website or App, or otherwise make (or allow any third party to make)
            material available by means of the Website or App (any such material,
            &ldquo;Content&rdquo;), You are entirely responsible for the content of, and
            any harm resulting from, that Content. That is the case regardless of
            whether the Content in question constitutes text, graphics, an audio file,
            or computer software. By making Content available, you represent and warrant
            that:
        </typography.P>
        <ul>
            <li>
                the downloading, copying and use of the Content will not infringe the
                proprietary rights, including but not limited to the copyright, patent,
                trademark or trade secret rights, of any third party;
            </li>
            <li>
                if your employer has rights to intellectual property you create, you
                have either (i) received permission from your employer to post or make
                available the Content, including but not limited to any software, or
                (ii) secured from your employer a waiver as to all rights in or to the
                Content;
            </li>
            <li>
                you have fully complied with any third-party licenses relating to the
                Content, and have done all things necessary to successfully pass through
                to end users any required terms;
            </li>
            <li>
                the Content does not contain or install any viruses, worms, malware,
                Trojan horses or other harmful or destructive content;
            </li>
            <li>
                the Content is not spam, is not machine- or randomly-generated, and does
                not contain unethical or unwanted commercial content designed to drive
                traffic to third party sites or boost the search engine rankings of
                third party sites, or to further unlawful acts (such as phishing) or
                mislead recipients as to the source of the material (such as spoofing);
            </li>
            <li>
                the Content is not pornographic, does not contain threats or incite
                violence, and does not violate the privacy or publicity rights of any
                third party;
            </li>
            <li>
                your content is not getting advertised via unwanted electronic messages
                such as spam links on newsgroups, email lists, other blogs and web
                sites, and similar unsolicited promotional methods;
            </li>
            <li>
                your content is not named in a manner that misleads your readers into
                thinking that you are another person or company. For example, your
                site&rsquo;s URL or name is not the name of a person other than yourself
                or company other than your own; and
            </li>
            <li>
                you have, in the case of Content that includes computer code, accurately
                categorized and/or described the type, nature, uses and effects of the
                materials, whether requested to do so by Joy or otherwise.
            </li>
        </ul>
        <typography.P>
            By submitting Content to Joy for inclusion on the Website or Application,
            you grant Joy a world-wide, royalty-free, and non-exclusive license to
            reproduce, modify, adapt and publish the Content solely for the purpose of
            displaying, distributing and promoting your site. If you delete Content, Joy
            will use reasonable efforts to remove it from the Website or App, but you
            acknowledge that caching or references to the Content may not be made
            immediately unavailable.
        </typography.P>
        <typography.P>
            Without limiting any of those representations or warranties, Joy has the
            right (though not the obligation) to, in Joy&rsquo;s sole discretion (i)
            refuse or remove any content that, in Joy&rsquo;s reasonable opinion,
            violates any Joy policy or is in any way harmful or objectionable, or (ii)
            terminate or deny access to and use of the Website or Application to any
            individual or entity for any reason, in Joy&rsquo;s sole discretion. Joy
            will have no obligation to provide a refund of any amounts previously paid.
        </typography.P>

        <h3>Payment and Renewal</h3>
        <ul>
            <li>
                General Terms: By selecting an Subscribe you agree to pay Joy the
                monthly or annual subscription fees indicated for that service. Payments
                will be charged on a pre-pay basis on the day you sign up for a
                Subscription and will cover the use of that service for a monthly or
                annual subscription period as indicated. Subscription fees are not
                refundable.
            </li>
            <li>
                Automatic Renewal: Unless you notify Joy before the end of the
                applicable subscription period that you want to cancel an Upgrade, your
                Upgrade subscription will automatically renew and you authorize us to
                collect the then-applicable annual or monthly subscription fee for such
                Upgrade (as well as any taxes) using any credit card or other payment
                mechanism we have on record for you. Subscriptions can be canceled at
                any time in the Subscription section of your account profile.
            </li>
        </ul>

        <h3>Responsibility of Website Visitors and Application Users</h3>
        <typography.P>
            Joy has not reviewed, and cannot review, all of the material, including
            computer software, posted to the Website or Application, and cannot
            therefore be responsible for that material&rsquo;s content, use or effects.
            By operating the Website and App, Joy does not represent or imply that it
            endorses the material there posted, or that it believes such material to be
            accurate, useful or non-harmful. You are responsible for taking precautions
            as necessary to protect yourself and your computer systems from viruses,
            worms, Trojan horses, and other harmful or destructive content. The Website
            and App may contain content that is offensive, indecent, or otherwise
            objectionable, as well as content containing technical inaccuracies,
            typographical mistakes, and other errors. The Website and App may also
            contain material that violates the privacy or publicity rights, or infringes
            the intellectual property and other proprietary rights, of third parties, or
            the downloading, copying or use of which is subject to additional terms and
            conditions, stated or unstated. Joy disclaims any responsibility for any
            harm resulting from the use by visitors of the Website and App, or from any
            downloading by those visitors of content there posted.
        </typography.P>

        <h3>Content Posted on Other Websites and Applications</h3>
        <typography.P>
            We have not reviewed, and cannot review, all of the material, including
            computer software, made available through the websites and applications to
            which joyapp.com links, and that link to joyapp.com. Joy does not have any
            control over those non-Joy websites and applications, and is not responsible
            for their contents or their use. By linking to a non-Joy website or
            application, Joy does not represent or imply that it endorses such website
            or application. You are responsible for taking precautions as necessary to
            protect yourself and your computer systems from viruses, worms, Trojan
            horses, and other harmful or destructive content. Joy disclaims any
            responsibility for any harm resulting from your use of non-Joy websites and
            applications.
        </typography.P>

        <h3>Copyright Infringement and DMCA Policy</h3>
        <typography.P>
            As Joy asks others to respect its intellectual property rights, it respects
            the intellectual property rights of others. If you believe that material
            located on or linked to by joyapp.com violates your copyright, you are
            encouraged to notify Joy in accordance with Joy&rsquo;s Digital Millennium
            Copyright Act (&ldquo;DMCA&rdquo;) Policy. Joy will respond to all such
            notices, including as required or appropriate by removing the infringing
            material or disabling all links to the infringing material. Joy will
            terminate a visitor&rsquo;s access to and use of the Website and Application
            if, under appropriate circumstances, the visitor is determined to be a
            repeat infringer of the copyrights or other intellectual property rights of
            Joy or others. In the case of such termination, Joy will have no obligation
            to provide a refund of any amounts previously paid to Joy.
        </typography.P>

        <h3>Intellectual Property</h3>
        <typography.P>
            This Agreement does not transfer from Joy to you any Joy or third party
            intellectual property, and all right, title and interest in and to such
            property will remain (as between the parties) solely with Joy. Joy,
            joyapp.com, the joyapp.com logo, and all other trademarks, service marks,
            graphics and logos used in connection with joyapp.com, or the Website and
            Joy are trademarks or registered trademarks of Joy or Joy&rsquo;s licensors.
            Other trademarks, service marks, graphics and logos used in connection with
            the Website or Application may be the trademarks of other third parties.
            Your use of the Website or App grants you no right or license to reproduce
            or otherwise use any Joy or third-party trademarks.
        </typography.P>

        <h3>Changes</h3>
        <typography.P>
            Joy reserves the right, at its sole discretion, to modify or replace any
            part of this Agreement. It is your responsibility to check this Agreement
            periodically for changes. Your continued use of or access to the Website or
            Application following the posting of any changes to this Agreement
            constitutes acceptance of those changes. Joy may also, in the future, offer
            new services and/or features through the Website or App (including, the
            release of new tools and resources). Such new features and/or services shall
            be subject to the terms and conditions of this Agreement.
        </typography.P>

        <h3>Termination</h3>
        <typography.P>
            Joy may terminate your access to all or any part of the Website or
            Application at any time, with or without cause, with or without notice,
            effective immediately. If you wish to terminate this Agreement or your
            joyapp.com account (if you have one), you may simply discontinue using the
            Website and App. All provisions of this Agreement which by their nature
            should survive termination shall survive termination, including, without
            limitation, ownership provisions, warranty disclaimers, indemnity and
            limitations of liability.
        </typography.P>

        <h3>Disclaimer of Warranties</h3>
        <typography.P>
            The Website and Application are provided &ldquo;as is&rdquo;. Joy and its
            suppliers and licensors hereby disclaim all warranties of any kind, express
            or implied, including, without limitation, the warranties of
            merchantability, fitness for a particular purpose and non-infringement.
            Neither Joy nor its suppliers and licensors, makes any warranty that the
            Website will be error free or that access thereto will be continuous or
            uninterrupted. You understand that you download from, or otherwise obtain
            content or services through, the Website or App at your own discretion and
            risk.
        </typography.P>

        <h3>Limitation of Liability</h3>
        <typography.P>
            In no event will Joy, or its suppliers or licensors, be liable with respect
            to any subject matter of this agreement under any contract, negligence,
            strict liability or other legal or equitable theory for: (i) any special,
            incidental or consequential damages; (ii) the cost of procurement for
            substitute products or services; (iii) for interruption of use or loss or
            corruption of data; or (iv) for any amounts that exceed the fees paid by you
            to Joy under this agreement during the twelve (12) month period prior to the
            cause of action. Joy shall have no liability for any failure or delay due to
            matters beyond their reasonable control. The foregoing shall not apply to
            the extent prohibited by applicable law.
        </typography.P>

        <h3>General Representation and Warranty</h3>
        <typography.P>
            You represent and warrant that (i) your use of the Website or Application
            will be in strict accordance with the Joy Privacy Policy, with this
            Agreement and with all applicable laws and regulations (including without
            limitation any local laws or regulations in your country, state, city, or
            other governmental area, regarding online conduct and acceptable content,
            and including all applicable laws regarding the transmission of technical
            data exported from the United States or the country in which you reside) and
            (ii) your use of the Website or App will not infringe or misappropriate the
            intellectual property rights of any third party.
        </typography.P>

        <h3>Indemnification</h3>
        <typography.P>
            You agree to indemnify and hold harmless Joy, its contractors, and its
            licensors, and their respective directors, officers, employees and agents
            from and against any and all claims and expenses, including attorneys&rsquo;
            fees, arising out of your use of the Website or Application, including but
            not limited to your violation of this Agreement.
        </typography.P>

        <h3>Miscellaneous</h3>
        <typography.P>
            This Agreement constitutes the entire agreement between Joy and you
            concerning the subject matter hereof, and they may only be modified by a
            written amendment signed by an authorized executive of Joy, or by the
            posting by Joy of a revised version. Except to the extent applicable law, if
            any, provides otherwise, this Agreement, any access to or use of the Website
            or Application will be governed by the laws of the state of Florida, U.S.A.,
            excluding its conflict of law provisions, and the proper venue for any
            disputes arising out of or relating to any of the same will be the state and
            federal courts located in Miami-Dade County, Florida. Except for claims for
            injunctive or equitable relief or claims regarding intellectual property
            rights (which may be brought in any competent court without the posting of a
            bond), any dispute arising under this Agreement shall be finally settled in
            accordance with the Comprehensive Arbitration Rules of the Judicial
            Arbitration and Mediation Service, Inc. (&ldquo;JAMS&rdquo;) by three
            arbitrators appointed in accordance with such Rules. The arbitration shall
            take place in Miami, Florida, in the English language and the arbitral
            decision may be enforced in any court. The prevailing party in any action or
            proceeding to enforce this Agreement shall be entitled to costs and
            attorneys&rsquo; fees. If any part of this Agreement is held invalid or
            unenforceable, that part will be construed to reflect the parties&rsquo;
            original intent, and the remaining portions will remain in full force and
            effect. A waiver by either party of any term or condition of this Agreement
            or any breach thereof, in any one instance, will not waive such term or
            condition or any subsequent breach thereof. You may assign your rights under
            this Agreement to any party that consents to, and agrees to be bound by, its
            terms and conditions; Joy may assign its rights under this Agreement without
            condition. This Agreement will be binding upon and will inure to the benefit
            of the parties, their successors and permitted assigns.
        </typography.P>
    </Layout>
);
